(function() {
    'use strict';

    angular
        .module('app')
        .config(routeConfig);

    routeConfig.$inject = ['$stateProvider', '$urlRouterProvider'];

    /* @ngInject */
    // route
    function routeConfig($stateProvider) {
        $stateProvider
            .state(pagesConfig.notAuthorized.name, {
                views: {
                    '': {
                        templateUrl: partialsConfig.notAuthorized.templateUrl,
                        controller: 'authCtrl',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    title: pagesConfig.notAuthorized.title,
                }

            });
    }
})();
